import _ from "lodash";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../jss_setup";
import { StyleTypeContext } from "../../umbilical_tools";
import { easyColors } from "../../jss_setup/colors";

const git_version = import.meta.env.VITE_APP_VERSION;

const whiteIcon =
  "https://apollob2c-demo.s3.ap-southeast-1.amazonaws.com/easy/assets/powered_by_easytravel_white.svg";

const styles = createUseStyles({
  PoweredBy: (props) => ({
    position: "absolute",
    right: `calc(${jssVariables.normal_gap} * -1)`,
    bottom: jssVariables.half_gap,
    borderRadius: "5px",
    padding: jssVariables.half_gap,
    background: easyColors.orange,
    transform: "scale(.6)",
    width: "max-content",
    ..._.get(props, "customStyles.PoweredBy", {}),
  }),
  icon: (props) => ({
    height: `calc(${jssVariables.navbar_height} / 2)`,
    cursor: "pointer",
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    PoweredBy: (props) => ({
      right: `calc(${jssVariables.normal_gap} * 3)`,
      ..._.get(props, "customStyles.PoweredBy.smallscreen", {}),
    }),
    icon: (props) => ({
      ..._.get(props, "customStyles.icon.smallscreen", {}),
    }),
  },
});
const PoweredBy = () => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = styles({
    customStyles: cStyler({
      type,
      brand,
      objName: "PoweredBy",
    }),
  });

  return (
    <div className={classes.PoweredBy} title={git_version}>
      <img
        src={whiteIcon}
        alt=""
        className={classes.icon}
        onClick={() => window.open("https://www.easytravel.tech/", "_blank")}
      />
    </div>
  );
};
PoweredBy.defaultProps = {};
PoweredBy.propTypes = {};
export default PoweredBy;
